import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import AppContext from "../../AppContext";

import { PieChart, Pie, Cell, BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer, } from 'recharts';


export default function Dots(props)
{


    const [dotVisible, setDotVisible] = useState("x");

 
    const [filterParam, setFilterParam] = useState({  

        men_dziennik_id: props.id,
        
         
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);



    const getTab = () => {
            
        
            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_men,dots', {
                method: 'POST', 
                body: JSON.stringify(filterParam), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setTab(res.result);             

                            if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
    }


    const openDot = (e) => {
            //atr-dot="p2"

            var dd = e.target.getAttribute("atr-dot");

            if(dd == dotVisible)
            {
                setDotVisible('x');
            }else {
                setDotVisible(dd);
            }

    }


    if(tab == null)
   {
      setTab([]);
      getTab(); 
      return <div>...</div>
   }

   if(tab.lista == undefined)
   {
            return <div>...</div>
   }




    const colors = ['#6aa44b', '#f25c37' ];
    const colors2 = ['#69b6bd', '#5482ac' ];

   
    var fData = new Array(); 

    if(tab != null)
    {
        fData = [
            {  nazwa: "Zrealizowane",  wartosc: tab.razem_zrealizowanych},
            {  nazwa: "Niezrealizowane", wartosc: tab.razem_niezrealizowanych },
        ];

        
    }




   return <div>

            <div className="raports">                 

                        <div className="rap_inline rap_half">

                                    <div className="rap_title">Realizacja programu</div>   
                                                <ResponsiveContainer width="100%" height={300}>
                                                        <PieChart width={200} height={300}>
                                                                    <Pie
                                                                    data={fData}
                                                                    dataKey="wartosc"
                                                                    nameKey="nazwa"
                                                                    cx="50%"
                                                                    cy="50%"
                                                                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                                                    labelLine={false}
                                                                    >
                                                                    {
                                                                        fData.map((entry, index) => (
                                                                        <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                                                                        ))
                                                                    }
                                                                    </Pie>
                                                        </PieChart>
                                                    </ResponsiveContainer>
                            </div>

                            <div className="rap_inline rap_half">
                                                                    <div className="men_book_info">
                                                                            <div className="men_book_num">{tab.razem_zrealizowanych}</div>
                                                                            <div className="men_book_text">Zrealizowanych punktów z {tab.razem_punktow}</div>
                                                                    </div>
                            </div>

               </div>

               <br/>

               <div className="men_dots">
 
                        <div className="dot_title" atr-dot="p1" onClick={openDot} > I. Fizyczny obszar rozwoju dziecka. Dziecko przygotowane do podjęcia nauki w szkole   </div>                     
                        {
                            tab.lista.map( (item,ix) => {
                                if(item.p1 != '1') return null;

                                if(dotVisible != 'p1') return null;

                                return  <div className="dot_sub">
                                            <span className="dotTitleX">{item.p2}. &nbsp; {item.opis} </span>
                                            <div className="dot_z">
                                                {
                                                    item.zajecia.length == 0 &&
                                                    <div className="dot_z_title_e">                                                    
                                                        Niezaliczone, ilość zajęć: {item.zajecia.length}
                                                    </div>
                                                }
                                                {
                                                    item.zajecia.length > 0 &&
                                                    <div className="dot_z_title">                                                    
                                                        Zaliczone, ilość zajęć: {item.zajecia.length}
                                                    </div>
                                                }
                                                
                                                <table className="table">
                                                    {
                                                        item.zajecia.map( (zz, zzInx) => {

                                                            var rowStyle = " row ";
                                                            if(zzInx % 2 == 0 )rowStyle = " row2 ";

                                                            return <tr className={rowStyle}>
                                                                <td>{zzInx+1}</td>
                                                                <td>{zz.dzien}</td>
                                                                <td>{zz.godzina_od.substring(0,5)}</td>
                                                                <td>{zz.temat}</td>
                                                                <td>
                                                                    {
                                                                        zz.nauczyciel != undefined &&
                                                                        <span>{zz.nauczyciel.nazwisko} {zz.nauczyciel.imie}</span>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        } )
                                                    }
                                                </table>
                                            </div>
                                     </div>
                            } )
                        }

                        <div className="dot_title" atr-dot="p2" onClick={openDot} > II. Emocjonalny obszar rozwoju dziecka.Dziecko przygotowane do podjęcia nauki w szkole </div>
                        {
                            tab.lista.map( (item,ix) => {
                                if(item.p1 != '2') return null;
                                if(dotVisible != 'p2') return null;

                                return  <div className="dot_sub"> 
                                            <span className="dotTitleX">{item.p2}. &nbsp; {item.opis}</span>
                                            <div className="dot_z">
                                                {
                                                    item.zajecia.length == 0 &&
                                                    <div className="dot_z_title_e">                                                    
                                                        Niezaliczone, ilość zajęć: {item.zajecia.length}
                                                    </div>
                                                }
                                                {
                                                    item.zajecia.length > 0 &&
                                                    <div className="dot_z_title">                                                    
                                                        Zaliczone, ilość zajęć: {item.zajecia.length}
                                                    </div>
                                                }
                                                
                                                <table className="table">
                                                    {
                                                        item.zajecia.map( (zz, zzInx) => {

                                                            var rowStyle = " row ";
                                                            if(zzInx % 2 == 0 )rowStyle = " row2 ";

                                                            return <tr className={rowStyle}>
                                                                <td>{zzInx+1}</td>
                                                                <td>{zz.dzien}</td>
                                                                <td>{zz.godzina_od.substring(0,5)}</td>
                                                                <td>{zz.temat}</td>
                                                                <td>
                                                                    {
                                                                        zz.nauczyciel != undefined &&
                                                                        <span>{zz.nauczyciel.nazwisko} {zz.nauczyciel.imie}</span>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        } )
                                                    }
                                                </table>
                                            </div>
                                        </div>
                            } )
                        }

                        <div className="dot_title" atr-dot="p3" onClick={openDot} > III. Społeczny obszar rozwoju dziecka. Dziecko przygotowane do podjęcia nauki w szkole</div>
                        {
                            tab.lista.map( (item,ix) => {
                                if(item.p1 != '3') return null;
                                if(dotVisible != 'p3') return null;

                                return  <div className="dot_sub">
                                             <span className="dotTitleX">{item.p2}. &nbsp; {item.opis}</span>
                                            <div className="dot_z">
                                                {
                                                    item.zajecia.length == 0 &&
                                                    <div className="dot_z_title_e">                                                    
                                                        Niezaliczone, ilość zajęć: {item.zajecia.length}
                                                    </div>
                                                }

                                                {
                                                    item.zajecia.length > 0 &&
                                                    <div className="dot_z_title">                                                    
                                                        Zaliczone, ilość zajęć: {item.zajecia.length}
                                                    </div>
                                                }
                                                
                                                <table className="table">
                                                    {
                                                        item.zajecia.map( (zz, zzInx) => {

                                                            var rowStyle = " row ";
                                                            if(zzInx % 2 == 0 )rowStyle = " row2 ";

                                                            return <tr className={rowStyle}>
                                                                <td>{zzInx+1}</td>
                                                                <td>{zz.dzien}</td>
                                                                <td>{zz.godzina_od.substring(0,5)}</td>
                                                                <td>{zz.temat}</td>
                                                                <td>
                                                                    {
                                                                        zz.nauczyciel != undefined &&
                                                                        <span>{zz.nauczyciel.nazwisko} {zz.nauczyciel.imie}</span>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        } )
                                                    }
                                                </table>
                                            </div>
                                        </div>
                            } )
                        }


                        <div className="dot_title" atr-dot="p4" onClick={openDot} > IV. Poznawczy obszar rozwoju dziecka. Dziecko przygotowane do podjęcia nauki w szkole </div>
                        {
                            tab.lista.map( (item,ix) => {
                                if(item.p1 != '4') return null;
                                if(dotVisible != 'p4') return null;

                                return  <div className="dot_sub"> 
                                            <span className="dotTitleX">{item.p2}. &nbsp; {item.opis}</span>
                                            <div className="dot_z">
                                                {
                                                    item.zajecia.length == 0 &&
                                                    <div className="dot_z_title_e">                                                    
                                                        Niezaliczone, ilość zajęć: {item.zajecia.length}
                                                    </div>
                                                }
                                                {
                                                    item.zajecia.length > 0 &&
                                                    <div className="dot_z_title">                                                    
                                                        Zaliczone, ilość zajęć: {item.zajecia.length}
                                                    </div>
                                                }
                                                
                                                <table className="table">
                                                    {
                                                        item.zajecia.map( (zz, zzInx) => {

                                                            var rowStyle = " row ";
                                                            if(zzInx % 2 == 0 )rowStyle = " row2 ";

                                                            return <tr className={rowStyle}>
                                                                <td>{zzInx+1}</td>
                                                                <td>{zz.dzien}</td>
                                                                <td>{zz.godzina_od.substring(0,5)}</td>
                                                                <td>{zz.temat}</td>
                                                                <td>
                                                                    {
                                                                        zz.nauczyciel != undefined &&
                                                                        <span>{zz.nauczyciel.nazwisko} {zz.nauczyciel.imie}</span>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        } )
                                                    }
                                                </table>
                                            </div>
                                        </div>
                            } )
                        }

               </div>
   </div>

}